import {useService} from '@cindedi/react-application';
import type {MetaFunction, LoaderFunction} from '@remix-run/node';
import {json} from '@remix-run/node';
import {Link, useLoaderData} from '@remix-run/react';
import {PublicLayout} from '~/domains/organization/components/PublicLayout';
import {seoMeta} from '~/domains/organization/utilities/seoMeta';

export interface IntercambioLoaderData {
  collaborations: Academic.PublicCollaborationDto[];
}

export const meta: MetaFunction = function IntercambioMeta({matches}) {
  return seoMeta('intercambio', {title: 'Intercâmbio - Cindedi', description: 'Saiba mais sobre as colaborações internacionais do CINDEDI! Conheça nossos parceiros e projetos que ampliam nossa pesquisa globalmente.'}, matches);
};

export const loader: LoaderFunction = async function IntercambioLoader({context: {use}}) {
  const Collaboration = use('Collaboration');

  const collaborations = await Collaboration.all();

  return json({
    collaborations: collaborations.sortBy('professor'),
  });
};

export default function IntercambioView() {
  const {collaborations} = useLoaderData<IntercambioLoaderData>();
  useService('organization/titlebar').setTitle('Intercâmbio');

  return (
    <PublicLayout>
      <ul role="list" className="flex flex-col gap-2">
        {collaborations.map((collaboration) => (
          <li key={collaboration.id} className="bg-shade-2 rounded">
            <div className="px-2 py-3 flex flex-col">
              {collaboration.curriculum ? (
                <Link
                  target="_blank"
                  className="font-semibold text-primary-12 hover:text-primary-10"
                  to={collaboration.curriculum}
                >
                  {collaboration.professor}
                </Link>
              ) : (
                <span className="font-semibold text-primary-12">{collaboration.professor}</span>
              )}
              <span>
                {collaboration.university} ({collaboration.country})
              </span>
              <div className="flex gap-2 text-shade-11 text-sm items-center mt-1">
                <span>{collaboration.research}</span>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </PublicLayout>
  );
}
